import React, { useState, useEffect } from 'react';
import { db, collection } from '../firebase';
import { getDocs, query, where } from 'firebase/firestore';
import ItemCard from './ItemCard';
import ItemForm from './ItemForm';
import ItemFilter from './ItemFilter';
import ConditionsModal from './ConditionsModal';
import iconB from '../assets/bot_4712139.png';
import './giv.css';
import { Link, useLocation } from 'react-router-dom';
import { Container, Box, Typography, Button } from '@mui/material';

const Giv = () => {
    const [items, setItems] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [showModal, setShowModal] = useState(true); // Initially show the modal
    const [animate, setAnimate] = useState(false);
    const location = useLocation();
    const [loading, setLoading] = useState(true);


    const handleButtonClick = () => {
        setAnimate(true);
        setTimeout(() => setAnimate(false), 300);
    };

    const fetchData = async (filters = {}) => {
        let q = query(collection(db, 'items_giv'), where('status', '==', 'checked'));

        const allItemsSnapshot = await getDocs(q);
        let allItems = allItemsSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));

        if (filters.category && filters.category.length > 0) {
            allItems = allItems.filter(item => filters.category.includes(item.category));
        }
        if (filters.name) {
            allItems = allItems.filter(item => item.name.toLowerCase().includes(filters.name.toLowerCase()));
        }
        if (filters.relevant) {
            allItems = allItems.filter(item => item.relevant === (filters.relevant === 'true'));
        }

        // Sort items locally by uploadDate
        allItems = sortItemsByDate(allItems);

        setItems(allItems);
    };

    // Local sorting function
    const sortItemsByDate = (items) => {
        return items.sort((a, b) => b.uploadDate.toDate() - a.uploadDate.toDate());
    };

    useEffect(() => {
        fetchData();
    }, []);

    const toggleForm = () => {
        setShowForm(!showForm);
    };

    const handleFilter = (filters) => {
        fetchData(filters);
    };

    const handleAcceptConditions = () => {
        setShowModal(false);
    };

    const handleFormSubmit = () => {
        setShowForm(false);  // Close the form after submission
        fetchData();  // Optionally refresh the items list
    };

    return (
        <div className="App">
            <div style={{ display: 'flex', justifyContent: 'flex-start', position: 'absolute' }}>
                {/* <Button
                    component={Link}
                    to={location.pathname === '/chat_m' ? '/chat_m' : '/chat_m'}
                    onClick={handleButtonClick}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        // padding: '8px 16px',
                        borderRadius: '30px',
                        backgroundColor: 'transparent',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                        width: '20%', // Half of the parent width

                    }}
                >
                    <img src={iconB} alt="Icon 2" style={{ width: '45px', height: '45px', border: 'solid 2px black', borderRadius: '30px' }} />
                </Button> */}


                <Box style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <Button
                        component={Link}
                        to={location.pathname === '/chat_m' ? '/chat_m' : '/chat_m'}
                        onClick={handleButtonClick}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column', // Change to column to stack items
                            alignItems: 'center',
                            textDecoration: 'none',
                            borderRadius: '30px',
                            backgroundColor: 'transparent',
                            flexGrow: 1,
                            justifyContent: 'center', // Center items vertically
                            width: '20%', // Half of the parent width
                        }}
                    >
                        <img
                            src={iconB}
                            alt="Icon 2"
                            style={{
                                width: '45px',
                                height: '45px',
                                border: 'solid 2px black',
                                borderRadius: '30px',
                                marginBottom: '8px', // Add some space between the image and text
                            }}
                        />
                        חזרה
                    </Button>
                </Box>

            </div>
            <h1 id='giv'>לוח יד 2</h1>
            <h3 id='giv2'>ציוד הדת הצה"לי</h3>
            {showModal && <ConditionsModal onAccept={handleAcceptConditions} />}
            {!showModal && (
                <>
                    {showForm && <ItemForm onFormSubmit={handleFormSubmit} />}
                    {!showForm && <>
                        <ItemFilter onFilter={handleFilter} />
                        <div className="items-list">
                            {items.map(item => (
                                <div className="item-card-container" key={item.id}>
                                    <ItemCard item={item} />
                                </div>
                            ))}
                        </div>
                    </>
                    }
                </>
            )}
            {!showForm && <>
                <div id='addItemDiv'>
                    {/* <div className="buttons-container"> */}
                    <button className="action-button add-button" onClick={toggleForm}>
                        <span>הוספת מודעה</span>
                    </button>
                    {/* </div> */}
                </div>
            </>}
        </div>
    );
}

export default Giv;
